import { render, staticRenderFns } from "./Staging-New-360-Request-Step4.vue?vue&type=template&id=7a44978e&scoped=true&"
import script from "./Staging-New-360-Request-Step4.vue?vue&type=script&lang=js&"
export * from "./Staging-New-360-Request-Step4.vue?vue&type=script&lang=js&"
import style0 from "./Staging-New-360-Request-Step4.vue?vue&type=style&index=0&id=7a44978e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a44978e",
  null
  
)

export default component.exports